import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import { compose } from 'redux';
import {
  collectionTotalNumberOfItemsSelector,
  viewRangeSelector,
  isCollectionLoadingSelector,
  collectionVideosSelector,
  sizeSelector,
} from 'common/selectors';
import { urlVideoIdSelector } from 'pages/channel.page';
import { urlSortSelector } from 'common/selectors/router';
import { isEqual } from 'lodash-es';
import { MobileContainerDecorated } from 'components/video-collection/mobile/container';

class MobileCollection extends React.Component {
  componentDidMount() {
    let pathname = this.props.history.location.pathname;
    const newPathname = `${this.props.baseUrl}/1/${this.props.videoId ? this.props.videoId : ''}`;
    if (newPathname !== pathname) {
      this.props.history.replace(newPathname);
    }
    this.props.dispatch(this.props.loadCollectionAction);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.loadCollectionAction.payload, prevProps.loadCollectionAction.payload)) {
      this.props.dispatch(this.props.loadCollectionAction);
    }
  }

  loadVideos = () => {
    this.props.dispatch(this.props.loadMoreAction);
  };

  render() {
    return (
      <MobileContainerDecorated
        baseUrl={this.props.baseUrl}
        loadMore={this.loadVideos}
        withSort={this.props.withSort}
        sortBy={this.props.sortBy}
      >
        {this.props.children}
      </MobileContainerDecorated>
    );
  }
}

const mapStateToProps = (state, props) => ({
  isLoading: isCollectionLoadingSelector(state),
  collectionTotalCount: collectionTotalNumberOfItemsSelector(state),
  collectionVideos: collectionVideosSelector(state),
  videoId: urlVideoIdSelector(state, props.match),
  sort: urlSortSelector(state, props.match),
  viewRange: viewRangeSelector(state),
  size: sizeSelector(state),
});

export const MobileCollectionDecorted = compose(withRouter, connect(mapStateToProps))(MobileCollection);

MobileCollectionDecorted.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  loadCollectionAction: PropTypes.object.isRequired,
  loadMoreAction: PropTypes.object.isRequired,
  withSort: PropTypes.bool,
  sortBy: PropTypes.array,
};
